<template>
  <section class="cta">
    <div class="cta-bg">
      <img :src="bg" alt="" v-if="bg"/>
      <div class="cta-mask"></div>
      <div class="grid-bg"></div>
    </div>
    <div class="page cta-inner reveal" v-reveal>
      <div class="cta-text">
        <span class="eyebrow">{{ eyebrow }}</span>
        <h2 class="h2">{{ title }}</h2>
        <p class="lead">{{ desc }}</p>
      </div>
      <div class="cta-actions">
        <router-link to="/contact" class="btn btn-primary">
          免费咨询
          <IconSvg name="arrow-right"/>
        </router-link>
        <a class="btn btn-ghost" :href="`tel:${company.phone}`">
          <IconSvg name="phone"/>
          {{ company.phone }}
        </a>
      </div>
    </div>
  </section>
</template>

<script>
import IconSvg from '@/components/common/IconSvg'
import { company } from '@/data/site'

export default {
  name: 'CtaBand',
  components: { IconSvg },
  props: {
    eyebrow: { type: String, default: 'Get Started' },
    title: { type: String, default: '把你的场景讲给我们听' },
    desc: { type: String, default: '从现场勘查到方案落地，皓辰提供一对一技术沟通，先判断可行性，再谈合作方式。' },
    bg: { type: String, default: '' }
  },
  data() {
    return { company }
  }
}
</script>

<style lang="scss" scoped>
.cta {
  position: relative;
  overflow: hidden;
  border-top: 1px solid var(--line);
  border-bottom: 1px solid var(--line);
}

.cta-bg {
  position: absolute;
  inset: 0;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
    opacity: 0.42;
  }

  .cta-mask {
    position: absolute;
    inset: 0;
    background:
      radial-gradient(ellipse 60% 100% at 12% 50%, rgba(34, 224, 255, 0.18), transparent 70%),
      linear-gradient(100deg, rgba(3, 7, 17, 0.96) 0%, rgba(5, 12, 27, 0.82) 55%, rgba(3, 7, 17, 0.94) 100%);
  }
}

.cta-inner {
  position: relative;
  padding: 76px 28px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 40px;
}

.cta-text {
  max-width: 640px;

  .h2 { margin-top: 16px; }
  .lead { margin-top: 14px; }
}

.cta-actions { display: flex; gap: 14px; flex-wrap: wrap; }

@media (max-width: 900px) {
  .cta-inner { flex-direction: column; align-items: flex-start; padding: 54px 18px; gap: 26px; }
  .cta-actions { width: 100%; }
}
</style>
